import React, { useContext, useEffect, useState } from "react";
import { Container, Col, Button, Form, Row, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import WalletItem from "../Wallet/Component/WalletItem";
import OrderItem from "../UserOrder/Component/OrderItemTile";
import ContextApp from "./../../../core/contexts/context.app";
import SplitNumber from "../../components/SplitNumber";
import ApiAuth from "../../../core/api/api.auth";
import ServiceStorage from "../../../core/services/service.storage";
import ApiUserWallet from "../../../core/api/api.userWallet";
import _ from "lodash";
import {
  IconClipBoard,
  IconLogout,
  IconWallet,
  IconUserProfile,
  IconWalletDeposit,
  IconWalletWithdraw,
  IconWalletRequest,
  IconWalletTransition,
  IconOrderAll,
  IconOrderCancle,
  IconOrderDown,
  IconOrderWaiting,
  IconOrder,
  IconWallet1,
  IconMobile,
  IconUserInfo,
  IconWalletDown,
  IconCall,
} from "../../../assets/icons";
const iconWalletDeposit = <IconWalletDeposit />;
const iconWalletTransition = <IconWalletTransition />;
const iconWalletRequest = <IconWalletRequest />;
const iconWalletWithdraw = <IconWalletWithdraw />;
const orderAllIcon = <IconOrderAll />;
const orderCancelIcon = <IconOrderCancle />;
const orderDoneIcon = <IconOrderDown />;
const orderWaitingIcon = <IconOrderWaiting />;

function Profile() {
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();
  const [liveData, setLiveData] = useState();
  const [loadingData, setLoadingData] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        if (!ctx.isAuth && !isMobile) {
          navigate("/login");
          return;
        }
        if (!isMobile) {
          setLoadingData(true);
          const response = await ApiUserWallet.getUserWallet();

          if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
            setLiveData(response.data);

            let userInfo = ServiceStorage.getUserInfo();
            if (userInfo) {
              userInfo.walletRiallBalance = response.data.riallBalance;
              userInfo.walletAvailableRiallBalance =
                response.data.useAvailableRiallBalance;
              ServiceStorage.setUserInfo(userInfo);
              ctx.setUserInfo(userInfo);
            }
          }

          setLoadingData(false);
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات کیف پول:", error);
      }
    })();
  }, [ctx.isAuth, navigate]);

  function signOut() {
    ApiAuth.logout({
      refreshToken: ServiceStorage.getRefreshToken(),
    });

    ctx.setIsAuth(false);
    navigate("/login");
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ToastContainer></ToastContainer> */}
      {isMobile ? (
        // حالت موبایل***********************************************
        <Container fluid className="main-content vh-100 fs-085 text-dark">
          <div className="pt-3">
            <div className="bg-light-1 p-2  rounded-3 border">
              <Row>
                <Col xs="auto" className="profile-svg pe-0">
                  <IconUserProfile fillColor="#abaebf" />
                </Col>
                <Col className=" my-auto">
                  <div className="d-flex align-items-center small-svg">
                    <div className="pe-1">
                      <IconUserInfo fillColor="#777" />
                    </div>
                    <div> {ctx.userInfo?.name}</div>
                  </div>
                  <div
                    className="d-flex align-items-center small-svg pt-3 mt-3 "
                    style={{ borderTop: "1px dashed #d1d3df" }}
                  >
                    <div className="pe-1">
                      <IconMobile fillColor="#777" />
                    </div>
                    <div> {ctx.userInfo?.phone}</div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="pt-2">
            <Card className="rounded-3  border-0 shadow-sm">
              <Card.Body>
                <div className="mb-3 pb-3 border-bottom border-light-subtle">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconClipBoard fillColor="#777" />
                  </span>
                  <Link className="text-dark ms-3" to="/order">
                    سفارش های من
                  </Link>
                </div>
                <div className="mb-3 pb-3 border-bottom border-light-subtle">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconWallet fillColor="#777" />
                  </span>
                  <Link className="text-dark ms-3" to="/wallet">
                    مشاهده کیف پول
                  </Link>
                </div>
                <div className="mb-3 pb-3 border-bottom border-light-subtle">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconWalletDown fillColor="#777" />
                  </span>
                  <Link className="text-dark ms-3" to="/withdrowFromWallet">
                    برداشت وجه
                  </Link>
                </div>
                <div className="mb-3 pb-3 border-bottom border-light-subtle">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconCall fillColor="#777" />
                  </span>
                  <Link className="text-dark ms-3" to="/contact">
                    تماس با پشتیبانی
                  </Link>
                </div>
                <div>
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconLogout fillColor="#777" />
                  </span>
                  <button
                    className="btn-no-style px-0 mx-3 text-dark"
                    onClick={signOut}
                  >
                    خروج از حساب کاربری
                  </button>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Container>
      ) : (
        // حالت دسکتاپ***********************************************

        <Container fluid className=" min-height-page">
          <Container className="mt-5">
            <Row className="pt-5">
              <Col xs={12} lg={4} className="pb-3 pb-lg-0">
                <div className="bg-light-blue  rounded-4 p-3 ">
                  <div className="d-flex align-items-center pb-3">
                    <div className="profile-svg">
                      <IconUserProfile />
                    </div>
                    <div className="ms-3">
                      <div className="mb-2">
                        <span className="fs-09 text-muted pe-1">نام :</span>
                        {ctx.userInfo?.name}
                      </div>
                      <div>
                        <span className="fs-09 text-muted pe-1">موبایل :</span>
                        {ctx.userInfo?.phone}
                      </div>
                    </div>
                  </div>

                  <Col
                    xs={12}
                    className="pt-3 border-top border-secondary-subtle"
                  >
                    <Button
                      variant="outline-primary border-0"
                      className="rounded-2 fs-09 px-3"
                      onClick={signOut}
                    >
                      {/* <BoxArrowRight size={15} /> */}
                      <IconLogout />
                      <span className="ps-1">خروج از حساب کاربری</span>
                    </Button>
                  </Col>
                </div>
              </Col>
              <Col md="6" lg={4} className="icon-menu">
                <div className="bg-light-blue p-3 border mb-3 mt-1 mt-md-0 rounded-4">
                  <div className="d-flex">
                    <div className="large-icons">
                      <IconWallet1 />
                    </div>
                    <div className="ms-3">
                      <div className="fw-bold text-large">
                        {loadingData ? (
                          <Skeleton height={15}></Skeleton>
                        ) : (
                          <SplitNumber
                            number={liveData?.riallBalance ? liveData?.riallBalance : 0 + " تومان"}
                          />
                        )}
                      </div>
                      <div className="text-gray fs-08">موجودی کیف پول</div>
                    </div>
                  </div>
                </div>
                <Row className="fs-08 gx-3">
                  <WalletItem
                    Icon={iconWalletDeposit}
                    PageLink="/profile"
                    Title="شارژ کیف پول"
                    Event={1}
                    RiallBalance={liveData?.useAvailableRiallBalance}
                  />
                  <WalletItem
                    Icon={iconWalletWithdraw}
                    PageLink="/profile"
                    Title="برداشت وجه"
                    Event={2}
                    RiallBalance={liveData?.useAvailableRiallBalance}
                  />
                  <WalletItem
                    Icon={iconWalletRequest}
                    PageLink="/withdrow"
                    Title="درخواست های برداشت"
                  />
                  <WalletItem
                    Icon={iconWalletTransition}
                    PageLink="/transaction"
                    Title="تراکنش های کیف پول"
                  />
                </Row>
              </Col>
              <Col md="6" lg={4} className="icon-menu">
                <div className="bg-light-blue p-3 border mb-3 mt-1 mt-md-0 rounded-4">
                  <div className="d-flex">
                    <div className="large-icons">
                      <IconOrder />
                    </div>
                    <div className="ms-3">
                      <div className="fw-bold text-large">
                        {ctx.userInfo?.basketCount + " سفارش "}{" "}
                      </div>
                      <div className="text-gray fs-08">تعداد کل سفارشات </div>
                    </div>
                  </div>
                </div>
                <Row className="gx-3 fs-08">
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderAllIcon}
                    title="همه سفارشها"
                    statusList={[0, 1, 2, 3]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderWaitingIcon}
                    title="جدید و در حال پردازش"
                    statusList={[0, 2]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderDoneIcon}
                    title="انجام شده"
                    statusList={[1]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderCancelIcon}
                    title="لغو شده"
                    statusList={[3]}
                  />
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      )}
    </>
  );
}
export default Profile;
